'use client';
import React from 'react';
import { useCart } from '@/contexts/CartContext';

export default function CartButton({
	className = '',
}: {
	className?: string;
}) {
	const { totalItems, setOpen } = useCart();

	return (
		<button
			aria-label="Open cart"
			onClick={() => setOpen(true)}
			className={`relative inline-flex items-center justify-center p-2 rounded-md hover:bg-gray-100 focus:outline-none ${className}`}
			title={`Open cart (${totalItems})`}
		>
			{/* Cart icon (simple SVG) */}
			<svg
				className="w-6 h-6 text-gray-700"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M3 3h2l.4 2M7 13h10l4-8H5.4"
				/>
				<circle cx="10" cy="20" r="1" />
				<circle cx="18" cy="20" r="1" />
			</svg>

			{/* Badge */}
			{totalItems > 0 && (
				<span
					className="absolute -top-1 -right-1 inline-flex items-center justify-center px-1.5 py-0.5 rounded-full text-xs font-semibold"
					style={{
						background: '#FFCF23',
						color: '#051449',
					}}
				>
					{totalItems}
				</span>
			)}
		</button>
	);
}
